import { HttpClient, HttpErrorResponse, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AppointmentInitiate, GetAvailableDoctorsData } from "../models/appointment";
import { PromiseResult } from "../models/PromiseResult";
import { ScheduleCreate, schedulequery, ScheduleBlock, DefaultSlotsQuery } from "../models/schedule";
import { RestApi } from "../shared/apiUrls";

@Injectable({
    providedIn: "root",
})
export class ScheduleService {
    constructor(private readonly http: HttpClient) { }

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }


    GetSchedules(query: schedulequery): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.ScheduleApi + 'fetch', query)
            .pipe(
                catchError(this.handleError)
            )
    }

    CreateSchedules(schedule: ScheduleCreate): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.ScheduleApi + 'Create', schedule)
            .pipe(
                catchError(this.handleError)
            )
    }

    GetAllAvailableDoctors(data: GetAvailableDoctorsData): Observable<PromiseResult> {
        return this.http.post<PromiseResult>(RestApi.Urls.ScheduleApi + 'fetch/schedule', data)
            .pipe(
                catchError(this.handleError)
            )
    }

    Block(user_guid: string, data: ScheduleBlock): Observable<PromiseResult> {
        return this.http.put<PromiseResult>(RestApi.Urls.ScheduleApi + 'remove/' + user_guid, data)
            .pipe(
                catchError(this.handleError)
            )
    }

    fetchDefault(body: AppointmentInitiate, query?: DefaultSlotsQuery): Observable<PromiseResult> {
        let params = new HttpParams();
        if (query && query.reschedule)
            params = params.append('reschedule', 'true');
        if (query && query.is_diet)
            params = params.append('is_diet', 'true');
        return this.http.post<PromiseResult>(RestApi.Urls.ScheduleApi + 'fetch/slots/default', body, { params })
            .pipe(
                catchError(this.handleError)
            )
    }

}
